import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import {
	Modal,
	ModalBody,
	ModalHeader,
	Button
  } from 'reactstrap';
import { FaRegImages} from 'react-icons/fa';
import TablaGalerias from './../components/TablaGalerias'; 

class ModalBlogGaleria extends Component {

	state = {
		redirect: false
	}

	setRedirect = () => {
		this.setState({
			redirect: true
		})
	}

	renderRedirect = () => {
		if (this.state.redirect) {
		  return <Redirect to='/gestorGaleria' />
		}
	}

	render(){
		const {data, isOpen, toggle, asociar} = this.props;   
		return (
			<Modal  isOpen={isOpen} toggle={toggle}   backdrop="static" className="modal-grande">
				<ModalHeader  toggle={toggle} >
					Asociar galería
				</ModalHeader>
				<ModalBody>
				{this.renderRedirect()}
				<div>Para ingresar una nueva galería o editar alguna existente, ir al módulo de galerías 
					<Button color="info" size="sm" style={{marginLeft:10}}  onClick={this.setRedirect}>
						<FaRegImages/> Ir a módulo Galería
					</Button>
				</div>
					
					<br/><br/>
					<TablaGalerias
						data = {data}
						eliminar = {null}
						editar = {null}
						asociar = {asociar}
						modo = {"blog"}
					/>    
				</ModalBody>
			</Modal>
		)
	}
};
export default ModalBlogGaleria;